@if(!clientsTasks){
<div><code>Loading ...</code></div>
}
@else{
<div class="table-container mat-mdc-card">  
  <app-datatable-component [data]="clientsTasks" [columns]="clientTasksColumns"></app-datatable-component>
</div>
}

